module.exports = __webpack_public_path__ + "static/trig_011-a04f1c6d280f96548efa53d89a95b195.webp";